// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "complaint-book-ms-" + ({"549":"app-book-presentation-pages-SelectCountry","723":"app-book-presentation-pages-Privacy"}[chunkId] || chunkId) + "-st-" + {"134":"5ada5349","462":"8a285399","508":"82115ca6","549":"59e651ed","723":"202f83b5","874":"cf8a4a07"}[chunkId] + ".js";
};